// extracted by mini-css-extract-plugin
module.exports = {"gwTileHeaderIcon":"tile-header-icon-hashed__gwTileHeaderIcon__2FzEN"};